// extracted by mini-css-extract-plugin
export var arrows = "_53-6";
export var decrementer = "_53-a";
export var disabled = "_53-4";
export var error = "_53-1";
export var hiddenText = "_53-b";
export var incrementer = "_53-9";
export var input = "_53-8";
export var inputWrapper = "_53-0";
export var leadingIcon = "_53-c";
export var readonly = "_53-3";
export var regular = "_53-7";
export var small = "_53-5";
export var warning = "_53-2";